module.exports = __webpack_public_path__ + "static/media/loader.f8a6d83f.gif";